import React from 'react';
import styled from 'styled-components';
import { useIntl } from '@leagueplatform/locales';
import { useConfigProperty } from '@leagueplatform/core';
import { Spinner, genesisStyled, Box } from '@leagueplatform/genesis-commons';
import { getScopedLegacyCssClassNames } from '@leagueplatform/web-common';
import type { LoadingIndicatorProps } from '../../types/loading-indicator.types';

const LoaderContainer = genesisStyled(Box)`
  min-height: 300px;
  position: relative;
  ${(props) =>
    !props.inline &&
    `
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    height: 100%;
    width: 100%;
  `};
`;

const IndicatorContainer = styled.div`
  width: 200px;
  height: 80px;
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
`;

const LoadingText = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
`;

export const LoadingIndicator = ({ inline }: LoadingIndicatorProps) => {
  const { formatMessage } = useIntl();
  const loadingConfig = useConfigProperty('core.ui.components.loading');

  const loadingComponent = loadingConfig?.element || (
    <Spinner isLoading renderLoadingText={false} />
  );

  const loadingMessage =
    loadingConfig?.text || formatMessage({ id: 'LOADING' });

  return (
    <LoaderContainer inline={inline} className={getScopedLegacyCssClassNames()}>
      <IndicatorContainer>
        {loadingComponent}
        {loadingConfig?.text !== false && (
          <LoadingText>{loadingMessage}</LoadingText>
        )}
      </IndicatorContainer>
    </LoaderContainer>
  );
};
